'use strict';

var cov_gft10of9 = function () {
  var path = '/Users/jvvbsocianova/Projects/socianova/marty/src/app/dashboard/dashboard.component.js',
      hash = '52432ab72f587dd02cc189db252d0695a18644d5',
      global = new Function('return this')(),
      gcv = '__coverage__',
      coverageData = {
    path: '/Users/jvvbsocianova/Projects/socianova/marty/src/app/dashboard/dashboard.component.js',
    statementMap: {
      '0': {
        start: {
          line: 3,
          column: 4
        },
        end: {
          line: 3,
          column: 25
        }
      },
      '1': {
        start: {
          line: 4,
          column: 4
        },
        end: {
          line: 4,
          column: 21
        }
      },
      '2': {
        start: {
          line: 5,
          column: 4
        },
        end: {
          line: 5,
          column: 25
        }
      },
      '3': {
        start: {
          line: 6,
          column: 4
        },
        end: {
          line: 6,
          column: 27
        }
      },
      '4': {
        start: {
          line: 7,
          column: 4
        },
        end: {
          line: 7,
          column: 27
        }
      },
      '5': {
        start: {
          line: 8,
          column: 4
        },
        end: {
          line: 8,
          column: 25
        }
      },
      '6': {
        start: {
          line: 9,
          column: 4
        },
        end: {
          line: 9,
          column: 25
        }
      },
      '7': {
        start: {
          line: 10,
          column: 4
        },
        end: {
          line: 10,
          column: 37
        }
      },
      '8': {
        start: {
          line: 11,
          column: 4
        },
        end: {
          line: 11,
          column: 35
        }
      },
      '9': {
        start: {
          line: 16,
          column: 4
        },
        end: {
          line: 16,
          column: 40
        }
      },
      '10': {
        start: {
          line: 18,
          column: 4
        },
        end: {
          line: 34,
          column: 6
        }
      },
      '11': {
        start: {
          line: 41,
          column: 4
        },
        end: {
          line: 50,
          column: 6
        }
      },
      '12': {
        start: {
          line: 53,
          column: 4
        },
        end: {
          line: 57,
          column: 6
        }
      },
      '13': {
        start: {
          line: 60,
          column: 4
        },
        end: {
          line: 64,
          column: 6
        }
      },
      '14': {
        start: {
          line: 67,
          column: 4
        },
        end: {
          line: 67,
          column: 33
        }
      },
      '15': {
        start: {
          line: 69,
          column: 4
        },
        end: {
          line: 69,
          column: 32
        }
      },
      '16': {
        start: {
          line: 82,
          column: 4
        },
        end: {
          line: 84,
          column: 5
        }
      },
      '17': {
        start: {
          line: 83,
          column: 6
        },
        end: {
          line: 83,
          column: 13
        }
      },
      '18': {
        start: {
          line: 86,
          column: 4
        },
        end: {
          line: 88,
          column: 5
        }
      },
      '19': {
        start: {
          line: 87,
          column: 6
        },
        end: {
          line: 87,
          column: 13
        }
      },
      '20': {
        start: {
          line: 91,
          column: 4
        },
        end: {
          line: 91,
          column: 31
        }
      },
      '21': {
        start: {
          line: 93,
          column: 4
        },
        end: {
          line: 120,
          column: 11
        }
      },
      '22': {
        start: {
          line: 99,
          column: 10
        },
        end: {
          line: 116,
          column: 13
        }
      },
      '23': {
        start: {
          line: 100,
          column: 12
        },
        end: {
          line: 100,
          column: 87
        }
      },
      '24': {
        start: {
          line: 102,
          column: 12
        },
        end: {
          line: 113,
          column: 13
        }
      },
      '25': {
        start: {
          line: 104,
          column: 16
        },
        end: {
          line: 104,
          column: 88
        }
      },
      '26': {
        start: {
          line: 105,
          column: 16
        },
        end: {
          line: 105,
          column: 22
        }
      },
      '27': {
        start: {
          line: 107,
          column: 16
        },
        end: {
          line: 107,
          column: 87
        }
      },
      '28': {
        start: {
          line: 108,
          column: 16
        },
        end: {
          line: 108,
          column: 22
        }
      },
      '29': {
        start: {
          line: 110,
          column: 16
        },
        end: {
          line: 110,
          column: 87
        }
      },
      '30': {
        start: {
          line: 111,
          column: 16
        },
        end: {
          line: 111,
          column: 22
        }
      },
      '31': {
        start: {
          line: 115,
          column: 12
        },
        end: {
          line: 115,
          column: 78
        }
      },
      '32': {
        start: {
          line: 118,
          column: 10
        },
        end: {
          line: 118,
          column: 41
        }
      },
      '33': {
        start: {
          line: 119,
          column: 10
        },
        end: {
          line: 119,
          column: 38
        }
      },
      '34': {
        start: {
          line: 130,
          column: 4
        },
        end: {
          line: 143,
          column: 5
        }
      },
      '35': {
        start: {
          line: 132,
          column: 8
        },
        end: {
          line: 132,
          column: 24
        }
      },
      '36': {
        start: {
          line: 133,
          column: 8
        },
        end: {
          line: 133,
          column: 14
        }
      },
      '37': {
        start: {
          line: 135,
          column: 8
        },
        end: {
          line: 135,
          column: 25
        }
      },
      '38': {
        start: {
          line: 136,
          column: 8
        },
        end: {
          line: 136,
          column: 14
        }
      },
      '39': {
        start: {
          line: 138,
          column: 8
        },
        end: {
          line: 138,
          column: 24
        }
      },
      '40': {
        start: {
          line: 139,
          column: 8
        },
        end: {
          line: 139,
          column: 14
        }
      },
      '41': {
        start: {
          line: 141,
          column: 8
        },
        end: {
          line: 141,
          column: 24
        }
      },
      '42': {
        start: {
          line: 142,
          column: 8
        },
        end: {
          line: 142,
          column: 14
        }
      },
      '43': {
        start: {
          line: 145,
          column: 4
        },
        end: {
          line: 155,
          column: 5
        }
      },
      '44': {
        start: {
          line: 146,
          column: 6
        },
        end: {
          line: 146,
          column: 101
        }
      },
      '45': {
        start: {
          line: 147,
          column: 6
        },
        end: {
          line: 147,
          column: 97
        }
      },
      '46': {
        start: {
          line: 148,
          column: 6
        },
        end: {
          line: 148,
          column: 91
        }
      },
      '47': {
        start: {
          line: 149,
          column: 6
        },
        end: {
          line: 149,
          column: 87
        }
      },
      '48': {
        start: {
          line: 150,
          column: 11
        },
        end: {
          line: 155,
          column: 5
        }
      },
      '49': {
        start: {
          line: 151,
          column: 6
        },
        end: {
          line: 151,
          column: 106
        }
      },
      '50': {
        start: {
          line: 152,
          column: 6
        },
        end: {
          line: 152,
          column: 102
        }
      },
      '51': {
        start: {
          line: 153,
          column: 6
        },
        end: {
          line: 153,
          column: 96
        }
      },
      '52': {
        start: {
          line: 154,
          column: 6
        },
        end: {
          line: 154,
          column: 92
        }
      },
      '53': {
        start: {
          line: 157,
          column: 4
        },
        end: {
          line: 157,
          column: 19
        }
      },
      '54': {
        start: {
          line: 161,
          column: 4
        },
        end: {
          line: 161,
          column: 43
        }
      },
      '55': {
        start: {
          line: 162,
          column: 4
        },
        end: {
          line: 162,
          column: 19
        }
      },
      '56': {
        start: {
          line: 170,
          column: 27
        },
        end: {
          line: 173,
          column: 5
        }
      },
      '57': {
        start: {
          line: 174,
          column: 4
        },
        end: {
          line: 175,
          column: 91
        }
      },
      '58': {
        start: {
          line: 183,
          column: 4
        },
        end: {
          line: 185,
          column: 5
        }
      },
      '59': {
        start: {
          line: 184,
          column: 6
        },
        end: {
          line: 184,
          column: 13
        }
      },
      '60': {
        start: {
          line: 187,
          column: 4
        },
        end: {
          line: 187,
          column: 68
        }
      },
      '61': {
        start: {
          line: 188,
          column: 4
        },
        end: {
          line: 188,
          column: 19
        }
      },
      '62': {
        start: {
          line: 192,
          column: 4
        },
        end: {
          line: 194,
          column: 5
        }
      },
      '63': {
        start: {
          line: 193,
          column: 6
        },
        end: {
          line: 193,
          column: 13
        }
      },
      '64': {
        start: {
          line: 196,
          column: 4
        },
        end: {
          line: 196,
          column: 66
        }
      },
      '65': {
        start: {
          line: 197,
          column: 4
        },
        end: {
          line: 197,
          column: 19
        }
      },
      '66': {
        start: {
          line: 202,
          column: 4
        },
        end: {
          line: 202,
          column: 68
        }
      },
      '67': {
        start: {
          line: 204,
          column: 4
        },
        end: {
          line: 204,
          column: 74
        }
      },
      '68': {
        start: {
          line: 206,
          column: 4
        },
        end: {
          line: 206,
          column: 43
        }
      },
      '69': {
        start: {
          line: 208,
          column: 4
        },
        end: {
          line: 208,
          column: 64
        }
      },
      '70': {
        start: {
          line: 210,
          column: 4
        },
        end: {
          line: 210,
          column: 19
        }
      },
      '71': {
        start: {
          line: 218,
          column: 4
        },
        end: {
          line: 218,
          column: 35
        }
      },
      '72': {
        start: {
          line: 219,
          column: 4
        },
        end: {
          line: 219,
          column: 19
        }
      },
      '73': {
        start: {
          line: 224,
          column: 0
        },
        end: {
          line: 233,
          column: 5
        }
      }
    },
    fnMap: {
      '0': {
        name: '(anonymous_0)',
        decl: {
          start: {
            line: 2,
            column: 2
          },
          end: {
            line: 2,
            column: 3
          }
        },
        loc: {
          start: {
            line: 2,
            column: 97
          },
          end: {
            line: 12,
            column: 3
          }
        }
      },
      '1': {
        name: '(anonymous_1)',
        decl: {
          start: {
            line: 14,
            column: 2
          },
          end: {
            line: 14,
            column: 3
          }
        },
        loc: {
          start: {
            line: 14,
            column: 12
          },
          end: {
            line: 70,
            column: 3
          }
        }
      },
      '2': {
        name: '(anonymous_2)',
        decl: {
          start: {
            line: 80,
            column: 2
          },
          end: {
            line: 80,
            column: 3
          }
        },
        loc: {
          start: {
            line: 80,
            column: 12
          },
          end: {
            line: 121,
            column: 3
          }
        }
      },
      '3': {
        name: '(anonymous_3)',
        decl: {
          start: {
            line: 97,
            column: 8
          },
          end: {
            line: 97,
            column: 9
          }
        },
        loc: {
          start: {
            line: 97,
            column: 18
          },
          end: {
            line: 120,
            column: 9
          }
        }
      },
      '4': {
        name: '(anonymous_4)',
        decl: {
          start: {
            line: 99,
            column: 38
          },
          end: {
            line: 99,
            column: 39
          }
        },
        loc: {
          start: {
            line: 99,
            column: 47
          },
          end: {
            line: 116,
            column: 11
          }
        }
      },
      '5': {
        name: '(anonymous_5)',
        decl: {
          start: {
            line: 127,
            column: 2
          },
          end: {
            line: 127,
            column: 3
          }
        },
        loc: {
          start: {
            line: 127,
            column: 32
          },
          end: {
            line: 158,
            column: 3
          }
        }
      },
      '6': {
        name: '(anonymous_6)',
        decl: {
          start: {
            line: 160,
            column: 2
          },
          end: {
            line: 160,
            column: 3
          }
        },
        loc: {
          start: {
            line: 160,
            column: 27
          },
          end: {
            line: 163,
            column: 3
          }
        }
      },
      '7': {
        name: '(anonymous_7)',
        decl: {
          start: {
            line: 169,
            column: 2
          },
          end: {
            line: 169,
            column: 3
          }
        },
        loc: {
          start: {
            line: 169,
            column: 27
          },
          end: {
            line: 176,
            column: 3
          }
        }
      },
      '8': {
        name: '(anonymous_8)',
        decl: {
          start: {
            line: 182,
            column: 2
          },
          end: {
            line: 182,
            column: 3
          }
        },
        loc: {
          start: {
            line: 182,
            column: 31
          },
          end: {
            line: 189,
            column: 3
          }
        }
      },
      '9': {
        name: '(anonymous_9)',
        decl: {
          start: {
            line: 191,
            column: 2
          },
          end: {
            line: 191,
            column: 3
          }
        },
        loc: {
          start: {
            line: 191,
            column: 29
          },
          end: {
            line: 198,
            column: 3
          }
        }
      },
      '10': {
        name: '(anonymous_10)',
        decl: {
          start: {
            line: 200,
            column: 2
          },
          end: {
            line: 200,
            column: 3
          }
        },
        loc: {
          start: {
            line: 200,
            column: 31
          },
          end: {
            line: 211,
            column: 3
          }
        }
      },
      '11': {
        name: '(anonymous_11)',
        decl: {
          start: {
            line: 217,
            column: 2
          },
          end: {
            line: 217,
            column: 3
          }
        },
        loc: {
          start: {
            line: 217,
            column: 30
          },
          end: {
            line: 220,
            column: 3
          }
        }
      }
    },
    branchMap: {
      '0': {
        loc: {
          start: {
            line: 82,
            column: 4
          },
          end: {
            line: 84,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 82,
            column: 4
          },
          end: {
            line: 84,
            column: 5
          }
        }, {
          start: {
            line: 82,
            column: 4
          },
          end: {
            line: 84,
            column: 5
          }
        }]
      },
      '1': {
        loc: {
          start: {
            line: 82,
            column: 8
          },
          end: {
            line: 82,
            column: 152
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 82,
            column: 9
          },
          end: {
            line: 82,
            column: 31
          }
        }, {
          start: {
            line: 82,
            column: 35
          },
          end: {
            line: 82,
            column: 55
          }
        }, {
          start: {
            line: 82,
            column: 61
          },
          end: {
            line: 82,
            column: 104
          }
        }, {
          start: {
            line: 82,
            column: 108
          },
          end: {
            line: 82,
            column: 151
          }
        }]
      },
      '2': {
        loc: {
          start: {
            line: 86,
            column: 4
          },
          end: {
            line: 88,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 86,
            column: 4
          },
          end: {
            line: 88,
            column: 5
          }
        }, {
          start: {
            line: 86,
            column: 4
          },
          end: {
            line: 88,
            column: 5
          }
        }]
      },
      '3': {
        loc: {
          start: {
            line: 86,
            column: 8
          },
          end: {
            line: 86,
            column: 77
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 86,
            column: 8
          },
          end: {
            line: 86,
            column: 30
          }
        }, {
          start: {
            line: 86,
            column: 34
          },
          end: {
            line: 86,
            column: 77
          }
        }]
      },
      '4': {
        loc: {
          start: {
            line: 102,
            column: 12
          },
          end: {
            line: 113,
            column: 13
          }
        },
        type: 'switch',
        locations: [{
          start: {
            line: 103,
            column: 14
          },
          end: {
            line: 105,
            column: 22
          }
        }, {
          start: {
            line: 106,
            column: 14
          },
          end: {
            line: 108,
            column: 22
          }
        }, {
          start: {
            line: 109,
            column: 14
          },
          end: {
            line: 111,
            column: 22
          }
        }, {
          start: {
            line: 112,
            column: 14
          },
          end: {
            line: 112,
            column: 22
          }
        }]
      },
      '5': {
        loc: {
          start: {
            line: 127,
            column: 15
          },
          end: {
            line: 127,
            column: 30
          }
        },
        type: 'default-arg',
        locations: [{
          start: {
            line: 127,
            column: 24
          },
          end: {
            line: 127,
            column: 30
          }
        }]
      },
      '6': {
        loc: {
          start: {
            line: 130,
            column: 4
          },
          end: {
            line: 143,
            column: 5
          }
        },
        type: 'switch',
        locations: [{
          start: {
            line: 131,
            column: 6
          },
          end: {
            line: 133,
            column: 14
          }
        }, {
          start: {
            line: 134,
            column: 6
          },
          end: {
            line: 136,
            column: 14
          }
        }, {
          start: {
            line: 137,
            column: 6
          },
          end: {
            line: 139,
            column: 14
          }
        }, {
          start: {
            line: 140,
            column: 6
          },
          end: {
            line: 142,
            column: 14
          }
        }]
      },
      '7': {
        loc: {
          start: {
            line: 145,
            column: 4
          },
          end: {
            line: 155,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 145,
            column: 4
          },
          end: {
            line: 155,
            column: 5
          }
        }, {
          start: {
            line: 145,
            column: 4
          },
          end: {
            line: 155,
            column: 5
          }
        }]
      },
      '8': {
        loc: {
          start: {
            line: 150,
            column: 11
          },
          end: {
            line: 155,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 150,
            column: 11
          },
          end: {
            line: 155,
            column: 5
          }
        }, {
          start: {
            line: 150,
            column: 11
          },
          end: {
            line: 155,
            column: 5
          }
        }]
      },
      '9': {
        loc: {
          start: {
            line: 183,
            column: 4
          },
          end: {
            line: 185,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 183,
            column: 4
          },
          end: {
            line: 185,
            column: 5
          }
        }, {
          start: {
            line: 183,
            column: 4
          },
          end: {
            line: 185,
            column: 5
          }
        }]
      },
      '10': {
        loc: {
          start: {
            line: 192,
            column: 4
          },
          end: {
            line: 194,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 192,
            column: 4
          },
          end: {
            line: 194,
            column: 5
          }
        }, {
          start: {
            line: 192,
            column: 4
          },
          end: {
            line: 194,
            column: 5
          }
        }]
      }
    },
    s: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0,
      '11': 0,
      '12': 0,
      '13': 0,
      '14': 0,
      '15': 0,
      '16': 0,
      '17': 0,
      '18': 0,
      '19': 0,
      '20': 0,
      '21': 0,
      '22': 0,
      '23': 0,
      '24': 0,
      '25': 0,
      '26': 0,
      '27': 0,
      '28': 0,
      '29': 0,
      '30': 0,
      '31': 0,
      '32': 0,
      '33': 0,
      '34': 0,
      '35': 0,
      '36': 0,
      '37': 0,
      '38': 0,
      '39': 0,
      '40': 0,
      '41': 0,
      '42': 0,
      '43': 0,
      '44': 0,
      '45': 0,
      '46': 0,
      '47': 0,
      '48': 0,
      '49': 0,
      '50': 0,
      '51': 0,
      '52': 0,
      '53': 0,
      '54': 0,
      '55': 0,
      '56': 0,
      '57': 0,
      '58': 0,
      '59': 0,
      '60': 0,
      '61': 0,
      '62': 0,
      '63': 0,
      '64': 0,
      '65': 0,
      '66': 0,
      '67': 0,
      '68': 0,
      '69': 0,
      '70': 0,
      '71': 0,
      '72': 0,
      '73': 0
    },
    f: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0,
      '11': 0
    },
    b: {
      '0': [0, 0],
      '1': [0, 0, 0, 0],
      '2': [0, 0],
      '3': [0, 0],
      '4': [0, 0, 0, 0],
      '5': [0],
      '6': [0, 0, 0, 0],
      '7': [0, 0],
      '8': [0, 0],
      '9': [0, 0],
      '10': [0, 0]
    },
    _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DashboardComponent = function () {
  function DashboardComponent($log, $state, $window, toastr, MartyService, AuthService, moment, $filter, lodash) {
    _classCallCheck(this, DashboardComponent);

    ++cov_gft10of9.f[0];
    ++cov_gft10of9.s[0];

    this.$state = $state;
    ++cov_gft10of9.s[1];
    this.$log = $log;
    ++cov_gft10of9.s[2];
    this.toastr = toastr;
    ++cov_gft10of9.s[3];
    this.$window = $window;
    ++cov_gft10of9.s[4];
    this.$filter = $filter;
    ++cov_gft10of9.s[5];
    this.lodash = lodash;
    ++cov_gft10of9.s[6];
    this.moment = moment;
    ++cov_gft10of9.s[7];
    this.martyService = MartyService;
    ++cov_gft10of9.s[8];
    this.authService = AuthService;
  }

  _createClass(DashboardComponent, [{
    key: '$onInit',
    value: function $onInit() {
      ++cov_gft10of9.f[1];
      ++cov_gft10of9.s[9];

      // user
      this.user = this.authService.user();
      // filters.
      ++cov_gft10of9.s[10];
      this.filters = {
        structures: this.authService.user('structures'),
        // type de periode.
        periodType: null,
        // activePeriodType
        activePeriodType: null,
        // selected indicator
        selectedIndicator: null,
        // sélection unique
        indicators: this.indicators,
        // sélection unique
        marts: this.marts,
        // start date
        startDate: this.moment().startOf('year'),
        // end date
        endDate: this.moment().endOf('year')
      };

      /**
       * Paramètre de recherche.
       * @type {Object}
       */

      ++cov_gft10of9.s[11];
      this.params = {
        // indicateur
        indicator: null,
        // structures
        structures: null,
        // date de début
        startDate: this.filters.startDate.format('YYYY-MM-DD'),
        // date de fin
        endDate: this.filters.endDate.format('YYYY-MM-DD')
      };

      // sort params.
      ++cov_gft10of9.s[12];
      this.sortParams = {
        type: 'date_valeur',
        reverse: false,
        search: ''
      };

      // available periodtype
      ++cov_gft10of9.s[13];
      this.availablePeriodType = {
        W: ["W", "M", "Y"],
        M: ["M", "Y"],
        Y: ["Y"]
      };

      // Valeur récupèrées du DATAWH
      ++cov_gft10of9.s[14];
      this.valuesFromDatawh = null;
      // is Fetching Data.
      ++cov_gft10of9.s[15];
      this.isFetchingData = false;
    }

    /**
     * Recupérer les structures en fonction du type
     */

    /**
     * Get values.
     */

  }, {
    key: 'getData',
    value: function getData() {
      var _this = this;

      ++cov_gft10of9.f[2];
      ++cov_gft10of9.s[16];

      // check dates.
      if ((++cov_gft10of9.b[1][0], !this.params.startDate) || (++cov_gft10of9.b[1][1], !this.params.endDate) || (++cov_gft10of9.b[1][2], this.params.startDate > this.params.endDate) || (++cov_gft10of9.b[1][3], this.params.endDate < this.params.startDate)) {
        ++cov_gft10of9.b[0][0];
        ++cov_gft10of9.s[17];

        return;
      } else {
        ++cov_gft10of9.b[0][1];
      }
      // check another indicator
      ++cov_gft10of9.s[18];
      if ((++cov_gft10of9.b[3][0], !this.params.indicator) || (++cov_gft10of9.b[3][1], this.lodash.isEmpty(this.params.structures))) {
        ++cov_gft10of9.b[2][0];
        ++cov_gft10of9.s[19];

        return;
      } else {
        ++cov_gft10of9.b[2][1];
      }

      // fetch data loader.
      ++cov_gft10of9.s[20];
      this.isFetchingData = true;

      ++cov_gft10of9.s[21];
      this.martyService.getValues(this.params).then(function (values) {
        ++cov_gft10of9.f[3];
        ++cov_gft10of9.s[22];

        // parsed
        _this.lodash.forEach(values, function (value) {
          ++cov_gft10of9.f[4];
          ++cov_gft10of9.s[23];

          value.date_valeur_fr = _this.moment(value.date_valeur).format('DD/MM/YYYY');
          // parsed date
          ++cov_gft10of9.s[24];
          switch (_this.filters.periodType) {
            case 'W':
              ++cov_gft10of9.b[4][0];
              ++cov_gft10of9.s[25];

              value.date_valeur = _this.moment(value.date_valeur).format('DD/MM/YYYY');
              ++cov_gft10of9.s[26];
              break;
            case 'M':
              ++cov_gft10of9.b[4][1];
              ++cov_gft10of9.s[27];

              value.date_valeur = _this.moment(value.date_valeur).format('MMMM YYYY');
              ++cov_gft10of9.s[28];
              break;
            case 'Y':
              ++cov_gft10of9.b[4][2];
              ++cov_gft10of9.s[29];

              value.date_valeur = _this.moment(value.date_valeur).format('MMMM YYYY');
              ++cov_gft10of9.s[30];
              break;
            default:
              ++cov_gft10of9.b[4][3];

          }
          // parsed value
          ++cov_gft10of9.s[31];
          value.formattedValue = _this.$filter('currency')(value.valeur, "");
        });

        ++cov_gft10of9.s[32];
        _this.valuesFromDatawh = values;
        ++cov_gft10of9.s[33];
        _this.isFetchingData = false;
      });
    }

    /**
     * Changer la période.
     */

  }, {
    key: 'changePeriod',
    value: function changePeriod() {
      var action = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (++cov_gft10of9.b[5][0], 'next');
      ++cov_gft10of9.f[5];

      var period = void 0;

      ++cov_gft10of9.s[34];
      switch (this.filters.activePeriodType) {
        case 'W':
          ++cov_gft10of9.b[6][0];
          ++cov_gft10of9.s[35];

          period = 'week';
          ++cov_gft10of9.s[36];
          break;
        case 'M':
          ++cov_gft10of9.b[6][1];
          ++cov_gft10of9.s[37];

          period = 'month';
          ++cov_gft10of9.s[38];
          break;
        case 'Y':
          ++cov_gft10of9.b[6][2];
          ++cov_gft10of9.s[39];

          period = 'year';
          ++cov_gft10of9.s[40];
          break;
        default:
          ++cov_gft10of9.b[6][3];
          ++cov_gft10of9.s[41];

          period = 'week';
          ++cov_gft10of9.s[42];
          break;
      }

      ++cov_gft10of9.s[43];
      if (action === 'next') {
        ++cov_gft10of9.b[7][0];
        ++cov_gft10of9.s[44];

        this.params.startDate = this.moment(this.params.startDate).add(1, period).format('YYYY-MM-DD');
        ++cov_gft10of9.s[45];
        this.params.endDate = this.moment(this.params.endDate).add(1, period).format('YYYY-MM-DD');
        ++cov_gft10of9.s[46];
        this.filters.startDate = this.moment(this.filters.startDate).add(1, period).toDate();
        ++cov_gft10of9.s[47];
        this.filters.endDate = this.moment(this.filters.endDate).add(1, period).toDate();
      } else {
          ++cov_gft10of9.b[7][1];
          ++cov_gft10of9.s[48];
          if (action === 'prev') {
            ++cov_gft10of9.b[8][0];
            ++cov_gft10of9.s[49];

            this.params.startDate = this.moment(this.params.startDate).subtract(1, period).format('YYYY-MM-DD');
            ++cov_gft10of9.s[50];
            this.params.endDate = this.moment(this.params.endDate).subtract(1, period).format('YYYY-MM-DD');
            ++cov_gft10of9.s[51];
            this.filters.startDate = this.moment(this.filters.startDate).subtract(1, period).toDate();
            ++cov_gft10of9.s[52];
            this.filters.endDate = this.moment(this.filters.endDate).subtract(1, period).toDate();
          } else {
            ++cov_gft10of9.b[8][1];
          }
        } // reload graph.
      ++cov_gft10of9.s[53];
      this.getData();
    }
  }, {
    key: 'changePeriodType',
    value: function changePeriodType(period) {
      ++cov_gft10of9.f[6];
      ++cov_gft10of9.s[54];

      this.filters.activePeriodType = period;
      ++cov_gft10of9.s[55];
      this.getData();
    }

    /**
     * Exporter
     */

  }, {
    key: 'exportValuesFromDatawh',
    value: function exportValuesFromDatawh() {
      ++cov_gft10of9.f[7];

      var periodInterval = (++cov_gft10of9.s[56], {
        startDate: this.moment(this.params.startDate).format('DD/MM/YYYY'),
        endDate: this.moment(this.params.endDate).format('DD/MM/YYYY')
      });
      ++cov_gft10of9.s[57];
      this.martyService.exportValues(this.valuesFromDatawh, this.filters.selectedIndicator, periodInterval);
    }

    /**
     * listen
     */

  }, {
    key: 'listenStartDateChange',
    value: function listenStartDateChange(value) {
      ++cov_gft10of9.f[8];
      ++cov_gft10of9.s[58];

      if (value > this.params.endDate) {
        ++cov_gft10of9.b[9][0];
        ++cov_gft10of9.s[59];

        return;
      } else {
        ++cov_gft10of9.b[9][1];
      }

      ++cov_gft10of9.s[60];
      this.params.startDate = this.moment(value).format('YYYY-MM-DD');
      ++cov_gft10of9.s[61];
      this.getData();
    }
  }, {
    key: 'listenEndDateChange',
    value: function listenEndDateChange(value) {
      ++cov_gft10of9.f[9];
      ++cov_gft10of9.s[62];

      if (value < this.params.startDate) {
        ++cov_gft10of9.b[10][0];
        ++cov_gft10of9.s[63];

        return;
      } else {
        ++cov_gft10of9.b[10][1];
      }

      ++cov_gft10of9.s[64];
      this.params.endDate = this.moment(value).format('YYYY-MM-DD');
      ++cov_gft10of9.s[65];
      this.getData();
    }
  }, {
    key: 'listenIndicatorChange',
    value: function listenIndicatorChange(value) {
      ++cov_gft10of9.f[10];
      ++cov_gft10of9.s[66];

      // period type
      this.filters.periodType = this.lodash.get(value, 'period_type');
      // active period type
      ++cov_gft10of9.s[67];
      this.filters.activePeriodType = this.lodash.get(value, 'period_type');
      // selected indicator
      ++cov_gft10of9.s[68];
      this.filters.selectedIndicator = value;
      // params indicator.
      ++cov_gft10of9.s[69];
      this.params.indicator = this.lodash.get(value, 'indicator');
      // get data
      ++cov_gft10of9.s[70];
      this.getData();
    }

    /**
     * Assignation des structures.
     */

  }, {
    key: 'listenTreeViewChange',
    value: function listenTreeViewChange(value) {
      ++cov_gft10of9.f[11];
      ++cov_gft10of9.s[71];

      this.params.structures = value;
      ++cov_gft10of9.s[72];
      this.getData();
    }
  }]);

  return DashboardComponent;
}();

++cov_gft10of9.s[73];


angular.module('app').component('dashboard', {
  bindings: {
    indicators: '<',
    marts: '<'
  },
  templateUrl: 'app/dashboard/dashboard.template.html',
  controller: DashboardComponent
});